import { Component, Input, Output, EventEmitter, inject } from '@angular/core';

import { MatIcon } from '@angular/material/icon';
import { AuthenticationService } from 'app/core/services/authentication.service';

@Component({
    selector: 'app-encounter-type-eligibilities-explainer',
    templateUrl: './encounter-type-eligibilities-explainer.component.html',
    styleUrls: ['./encounter-type-eligibilities-explainer.component.scss'],
    imports: [MatIcon]
})
export class EncounterTypeEligibilitiesExplainerComponent {
  private authService = inject(AuthenticationService);

  @Input() expanded = true;

  @Output() expandOrCollapse = new EventEmitter<boolean>();

  onExpandOrCollapseClick(expanded: boolean) {
    this.expanded = expanded;
    this.expandOrCollapse.emit(expanded);
  }

  get displayCaptureAdminContent() {
    return this.authService.isCaptureAdminUser && !this.authService.viewingAsClient;
  }
}
